import { AfterViewInit, Component, Input, OnChanges, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { BoundingBoxOverlayVm } from './bounding-box-overlay.model';
import { BoundingBoxOverlayPresenter } from './bounding-box-overlay.presenter';
import { ClassificationResult } from '@jump-tech-frontend/domain';

@Component({
  selector: 'crds-bounding-box-overlay',
  imports: [AsyncPipe],
  templateUrl: './bounding-box-overlay.component.html',
  styleUrls: ['./bounding-box-overlay.component.scss']
})
export class BoundingBoxOverlayComponent implements OnChanges, AfterViewInit {
  private presenter = inject(BoundingBoxOverlayPresenter);

  @Input() imageIndex: number;
  @Input() questionKey: string;
  @Input() classificationResult: ClassificationResult | undefined;
  @Input() showOverlay: boolean;

  vm$: BehaviorSubject<BoundingBoxOverlayVm> = new BehaviorSubject<BoundingBoxOverlayVm>(null);
  private viewInitialized = false;

  ngAfterViewInit(): void {
    this.viewInitialized = true;
    // Use requestAnimationFrame to ensure the sibling component has painted
    requestAnimationFrame((): void => {
      this.loadViewModel();
    });
  }

  ngOnChanges(): void {
    // Only load if view is initialized to avoid early DOM queries
    if (this.viewInitialized) {
      requestAnimationFrame((): void => {
        this.loadViewModel();
      });
    }
  }

  private loadViewModel(): void {
    this.presenter.load(this.vm$, this.imageIndex, this.questionKey, this.classificationResult, this.showOverlay);
  }
}
